module.exports = __webpack_public_path__ + "img/DESIGN_05_prew.a515d98d.jpg";